const REMOVE_CONDITION_TYPE = 'condition/REMOVE_CONDITION_TYPE'
const ADD_CONDITION_TYPE = 'condition/ADD_CONDITION_TYPE'
const UPDATE_CONDITION_TYPE = 'condition/UPDATE_CONDITION_TYPE'

export const types = { REMOVE_CONDITION_TYPE, ADD_CONDITION_TYPE, UPDATE_CONDITION_TYPE }

export const removeConditionType = (path, field) => ({ type: REMOVE_CONDITION_TYPE, path, field })
export const addConditionType = (path, field, conditionType) => ({ type: ADD_CONDITION_TYPE, path, field, conditionType })
export const updateConditionType = (path, field, attributes) => ({ type: UPDATE_CONDITION_TYPE, path, field, attributes })
